import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { get } from 'lodash';

interface ICountry {
  name: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class CountryListService {
  private list: Array<ICountry> = [];

  constructor(private readonly apiService: ApiService) {}

  loadData(): void {
    this.apiService
      .get$('json/country-list.json', {})
      .toPromise()
      .then(response => {
        this.list = response;
      });
  }

  getList(): Array<ICountry> {
    //when calling getList in ngFor this.list is empty
    if (get(this.list, 'length', 0) === 0) {
      this.loadData();
    }
    return this.list;
  }
}
